import { render } from "./CollectionProduct.vue?vue&type=template&id=74c6da3b"
import script from "./CollectionProduct.vue?vue&type=script&lang=js"
export * from "./CollectionProduct.vue?vue&type=script&lang=js"

import "./CollectionProduct.vue?vue&type=style&index=0&id=74c6da3b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__